import script from "./PaginatedList.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginatedList.vue?vue&type=script&setup=true&lang=js"

import "./PaginatedList.vue?vue&type=style&index=0&id=f728cb0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f728cb0e"]])

export default __exports__